<template>
  <div class="text-editor">
    <CkeditorResizable :default-height="300" :min-height="120">
      <ckeditor
        :editor="editor"
        :model-value="editorData"
        :config="editorConfig"
        @input="onEditorInput"
      />
    </CkeditorResizable>
  </div>
</template>

<script>
import { ref } from 'vue'

import Editor from 'ckeditor5-custom-build/build/ckeditor'
import CkeditorResizable from '@/components/elements/CkeditorResizable.vue'
import { sanitizeEditorHtml } from '@/helpers/unwrapEditorHtml.js'

export default {
  name: 'TextEditorBlock',
  components: {
    CkeditorResizable
  },
  props: {
    editorData: {
      type: String,
      default: ''
    }
  },
  emits: ['edit-data'],
  setup (props, { emit }) {
    const editor = ref(Editor)
    const editorConfig = ref({})

    const onEditorInput = (html) => {
      emit('edit-data', sanitizeEditorHtml(html))
    }

    return {
      editor,
      editorConfig,
      onEditorInput
    }
  }
}
</script>
<style>
.text-editor ul {
  padding-left: 35px;
}
.text-editor ol {
  padding-left: 35px;
}
.text-editor {
  p, h1, h2, h3, h4, h5, h6 {
    text-indent: 15px;
  }
}
.text-editor li {
  list-style-type: inherit !important;
}
</style>

<style lang="scss" scoped>
:deep(.ck-content) {
  border-radius: 0 !important;
  border: 1px solid #000000 !important;
  border-top: none !important;
  border-bottom: none !important;
}
:deep(.ck-toolbar) {
  border: 1px solid #000000 !important;
}
</style>
